import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Icon from '@material-ui/core/Icon';

import ConfirmDialogComponent from '../../common/confirmDialog.component';
import { updateFileActive } from '../../../store/actions/session.actions';

const styles = theme => ({
  icon: {
    marginRight: theme.spacing.unit,
  },
  buttonDelete: {
    float: 'right',
    color: theme.palette.red,
  },
  buttonRestore: {
    float: 'right',
    color: theme.palette.green,
  },
});

class ToggleActiveFileButtonContainer extends React.Component {
  constructor(props) {
    super(props);

    this.activateFile = this.activateFile.bind(this);

    this.state = {
      isBusy: false,
    };
  }

  activateFile(e) {

    const { sessionId, fileId, setActive } = this.props;

    this.setState({ isBusy: true });
    this.props.updateFileActive(sessionId, fileId, setActive);
  }

  renderButton(actionActive = false) {
    const {
      classes,
      label,
      icon,
      disabled
    } = this.props;

    return (
      <Button
        onClick={() => (actionActive ? this.activateFile() : null)}
        color="primary"
        className={label === 'Delete' || 'Ignore' ? classes.buttonDelete : classes.buttonRestore}
        disabled={this.state.isBusy || disabled}
      >
        <Icon className={classes.icon}>{icon}</Icon>
        {label}
      </Button>
    );
  }

  renderDialog() {
    return (
      <ConfirmDialogComponent
        title="Are you sure?"
        bodyText={this.props.bodyText ||"Are you sure you want to delete the file from the source files list?"}
        action={this.activateFile}
      >
        {this.renderButton()}
      </ConfirmDialogComponent>
    );
  }

  render() {
    return this.props.confirmAction ? this.renderDialog() : this.renderButton(true);
  }
}

ToggleActiveFileButtonContainer.propTypes = {
  sessionId: PropTypes.string.isRequired,
  fileId: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  icon: PropTypes.string,
  setActive: PropTypes.bool,
  updateFileActive: PropTypes.func.isRequired,
  confirmAction: PropTypes.bool,
  /* eslint-disable react/forbid-prop-types */
  classes: PropTypes.object.isRequired,
  bodyText: PropTypes.string,
  /* eslint-enable */
  disabled: PropTypes.bool
};

ToggleActiveFileButtonContainer.defaultProps = {
  setActive: false,
  confirmAction: false,
};

export default withStyles(styles)(connect(
  null,
  { updateFileActive },
)(ToggleActiveFileButtonContainer));
